import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import * as stylex from '@stylexjs/stylex';
import { palette } from '@shared/tokens/palette.stylex';

export const styles = stylex.create({
  employeeContainer: {
    display: 'flex',
    padding: '8px 12px',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
    alignSelf: 'stretch',
  },
  employeeCheckbox: {
    display: 'flex',
    width: '20px',
    height: '20px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  employeeInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: '1 0 0',
    minWidth: 0,
  },
  employeeFullname: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '20px',
    color: colors.primaryText,
  },
  employeePosition: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '16px',
    color: colors.secondaryText,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  remoteStatus: {
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: '12px',
    color: palette['grey-700'],
    background: palette['grey-100'],
    borderRadius: anatomy.borderRadiusRound,
    padding: '4px 8px',
    display: 'inline-block',
    marginLeft: '8px',
  },
});
